$(document).ready(function(){
  $('.play-btn__icon .playbtn-icon').on('click', function () {
    var $parentMedia = $(this).closest('.custom-video__media');
    var $video = $parentMedia.find('video')[0];
    
    // Play the video
    $video.play();

    // Hide play button, show pause button
    $(this).hide();
    $(this).siblings('.pausebtn-icon').show();

    // Hide the thumbnail image
    $parentMedia.find('.custom-video__img').hide();
    
    // Add active class to the parent element
    $parentMedia.addClass('custom-video__media--active');

    // Pause all other videos
    $('video').each(function () {
      if (this !== $video) {
        this.pause();
        this.currentTime = 0;  // Reset video to the beginning

        // Show play button and hide pause button on other videos
        var $media = $(this).closest('.custom-video__media');
        $media.find('.playbtn-icon').show();
        $media.find('.pausebtn-icon').hide();
        $media.find('.custom-video__img').show();

        // Remove active class from other videos' parent elements
        $media.removeClass('custom-video__media--active');
      }
    });
  });

  // Pause video on pause button click and show play icon
  $('.play-btn__icon .pausebtn-icon').on('click', function () {
    var $parentMedia = $(this).closest('.custom-video__media');
    var $video = $parentMedia.find('video')[0];

    // Pause the video
    $video.pause();

    // Show play button, hide pause button
    $(this).hide();
    $(this).siblings('.playbtn-icon').show();

    // Show the thumbnail image
    $parentMedia.find('.custom-video__img').show();

    // Remove active class from the parent element
    $parentMedia.removeClass('custom-video__media--active');
  });

  // When the video ends, reset play button and show the thumbnail image
  $('video').on('ended', function () {
    var $parentMedia = $(this).closest('.custom-video__media');
    
    // Reset video to the beginning
    this.currentTime = 0;

    // Show play button, hide pause button
    $parentMedia.find('.playbtn-icon').show();
    $parentMedia.find('.pausebtn-icon').hide();

    // Show the thumbnail image
    $parentMedia.find('.custom-video__img').show();

    // Remove active class from the parent element
    $parentMedia.removeClass('custom-video__media--active');
  });
  $('.custom-video__wrapper').slick({
        slidesToShow: 3,
        autoplay: false,
        slidesToScroll: 1,
        arrows: false,

        dots: false,
        prevArrow: "<button type='button' class='slick-prev icon-angle-left'><i class='demo-icon icon-left'></i></button>",
        nextArrow: "<button type='button' class='slick-next icon-angle-right'><i class='demo-icon icon-right'></i></button>",
        responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
             {
        breakpoint: 569,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
    });
  
   $(".slider-for").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    asNavFor: ".slider-nav",
    infinite: false,
    dots: false,
    prevArrow: `<button type='button' class='slick-prev icon-angle-left'><img src="https://cdn.shopify.com/s/files/1/0255/1729/3613/files/top-left-slider-arrow.png?v=1719402708"></button>`,
    nextArrow: `<button type='button' class='slick-next icon-angle-right'><img src="https://cdn.shopify.com/s/files/1/0255/1729/3613/files/top-right-slider-arrow.png?v=1719402707"></button>`,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
        },
      },
    ],
  });
  $(".slider-nav").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: ".slider-for",
    dots: false,
    arrows: false,
    focusOnSelect: true,
    infinite: false,
    verticalSwiping:true,
    vertical:true,
    prevArrow: `<button type='button' class='slick-prev icon-angle-left'><img src="https://cdn.shopify.com/s/files/1/0255/1729/3613/files/left-arrow-slider.png?v=1719384457"></button>`,
    nextArrow: `<button type='button' class='slick-next icon-angle-right'><img src="https://cdn.shopify.com/s/files/1/0255/1729/3613/files/right-arrow-slider.png?v=1719384548"></button>`,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          verticalSwiping:false,
    vertical:false,
        },
      },
    ],
  });
    $(".custom-banner__wrapper").slick({
      slidesToShow: 1,
      infinite: false,
      slidesToScroll: 1,
      autoplay: false,
      dots: true,
      arrows: false,
    });
  $(".work-wonders__wrapper").slick({
      slidesToShow: 4,
      infinite: false,
      slidesToScroll: 1,
      autoplay: false,
      dots: true,
      arrows: false,
        responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          
        },
        
      },
                {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          
        },
        
      },
                  {
        breakpoint: 569,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          
        },
        
      },
    ],
    });
  // $(".custom-collection-grid").slick({
  //     slidesToShow: 3,
  //     infinite: false,
  //     slidesToScroll: 1,
  //     autoplay: false,
  //     dots: true,
  //     arrows: false,
  //           responsive: [
  //         {
  //           breakpoint: 992,
  //           settings: {
  //           slidesToShow: 2,
  //         },
  //       },
  //       {
  //         breakpoint: 567,
  //         settings: {
  //         slidesToShow: 1,
  //       },
  //     } 
  //     ],
  //   });
    $(".our-testimonials__wrapper").slick({
      slidesToShow: 3,
      infinite: false,
      slidesToScroll: 1,
      autoplay: false,
      dots: true,
      arrows: false,
      centerMode: false,
      centerPadding: '0px',
        responsive: [
          {
            breakpoint: 992,
            settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 567,
          settings: {
          slidesToShow: 1,
        },
      } 
      ],
    });
  $('.image_accordion .toggle').click(function(e) {
    e.preventDefault();
    
    let $this = $(this);
    
    if ($this.next().hasClass('show')) {
        $this.next().removeClass('show');
        $this.next().slideUp(350);
    } else {
        $this.closest('.image_accordion').find('.inner').removeClass('show');
        $this.closest('.image_accordion').find('.inner').slideUp(350);
        $this.next().toggleClass('show');
        $this.next().slideToggle(350);
    }
});

$('.image_accordion li a').on('click', function(){
    $(this).parent().siblings().removeClass('active');
    $(this).parent().toggleClass('active');
});

   
});